<template>
  <EditorDeckSlidesSiteEditorSlide
    v-model:site-data="siteDataBeingEdited"
    :site="siteBeingEdited"
    :slide="slideBeingEdited as DeepReadonly<SiteSlideType>"
    :is-editing="true"
    :slide-refresh-key="currentIndex"
    :three-d-viewer="threeDViewer"
    :camera-id="slideBeingEdited.site_id === siteBeingEdited.siteId ? slideBeingEdited.camera_id : null"
    @update:slide="handleSave"
    @leave-edit-scene="$emit('exit')"
  >
    <template #edit-controls="{ actions: { saveCamera } }">
      <VButton class="mr-4" size="xs" @click="saveCamera">Save and Next</VButton>
      <VButton size="xs" @click="$emit('exit')">Cancel</VButton>
    </template>

    <template #message-banner>
      <div class="p-4">
        <VMessage :show="!hideMessage" banner-type="info" class="items-center" @dismiss="hideMessage = true">
          Click and drag to set a camera angle
        </VMessage>
      </div>
    </template>
  </EditorDeckSlidesSiteEditorSlide>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { ref, computed } from 'vue'

import type { Site } from '@/entities/site'
import type { IncludeSiteCamera, Slide } from '@/entities/deck'
import type { UseThreeDViewer } from '@/composables/useThreeDViewer'
import type { SiteSlide as SiteSlideType } from '@/entities/deck'

const props = defineProps({
  selectedSlides: {
    type: Array as PropType<DeepReadonly<Slide[]>>,
    required: true,
  },
  threeDViewer: {
    type: Object as PropType<UseThreeDViewer>,
    required: true,
  },
})

const emit = defineEmits(['update:slide', 'exit'])

const currentIndex = ref(0)
const hideMessage = ref(false)
const siteDataBeingEdited = ref<Site | null>(null)
const slideBeingEdited = computed(() => props.selectedSlides[currentIndex.value])
const siteBeingEdited = computed(() => {
  const siteId = props.selectedSlides[currentIndex.value].site_id

  return {
    siteId,
    cameraId: null,
    initialState: { coordinate: null, zoom: null },
    selectedHotspot: null,
    siteHistory: [],
  }
})

function handleSave(slide: Partial<Slide & IncludeSiteCamera>) {
  emit('update:slide', slide)

  if (!slide.site_camera) {
    return
  }

  if (currentIndex.value < props.selectedSlides.length - 1) {
    currentIndex.value++
  } else {
    emit('exit')
  }
}
</script>
